export default {
  ENDPOINTS: {
    LOGOUT: 'cf-api-login/v1/authentication/logout',
    REFRESH_TOKEN: 'cf-api-login/v1/authentication/refresh-token',
    REFRESH_TOKEN_CB: 'cb-api-auth/authentication/refresh-token',
    REFRESH_SESSION_DATA: 'cf-api-login/v1/token/tokens-by-claims'
  },
  REFRESH_TOKEN_LENDING_ABSOLUTE_URL: "https://api.".concat(window.ENVIRONMENT, ".cf.zinia.com/cf-api-login/v1/authentication/refresh-token")
};